import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { environment } from '../../../../../environments/environment';
import { currentUser } from '../../../../core/auth';
import { AppState } from '../../../../core/reducers';
import { QueryParamsModel, QueryResultsModel } from '../../../../core/_base/crud';
import { Template } from '../models';

@Injectable({ providedIn: 'root' })
export class FormsTemplateService {
  private companyId;
  private baseUrl = environment.FORMS_CONCEPTS_BASE;
  private currentUserType;

  constructor(private http: HttpClient, private store: Store<AppState>) {
    this.store.select(currentUser).subscribe((user) => {
      this.companyId = user.companyID;
      this.currentUserType = user.userType;
    });
  }

  private static getTemplatePageQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.isActive) fromString += `&is_active=${filter.isActive}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}`;
    } else {
      if (filter.id) fromString += `&id_has=${filter.id}`;
      if (filter.name) fromString += `&name_has=${filter.name}`;
      if (filter.origin) fromString += `&created_by_super_admin=${filter.origin}`;
    }

    return fromString;
  }

  getTemplatePage(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const params = new HttpParams({
      fromString: FormsTemplateService.getTemplatePageQueryString(queryParams),
    });

    return this.http.get<QueryResultsModel>(
      `${this.baseUrl}/companies/${
        this.currentUserType === 'Super Admin' ? '0' : this.companyId
      }/docmosis/templates`,
      { params },
    );
  }

  findTemplates(isSuperAdmin: boolean, searchTerm: string): Observable<QueryResultsModel> {
    const queryParams = new QueryParamsModel({ searchTerm }, 'asc', 'name', 0, 25);

    const params = new HttpParams({
      fromString: FormsTemplateService.getTemplatePageQueryString(queryParams),
    });

    return this.http.get<QueryResultsModel>(
      `${this.baseUrl}/companies/${isSuperAdmin ? 0 : this.companyId}/docmosis/templates`,
      { params },
    );
  }

  findAllTemplates(): Observable<any> {
    return this.http.get<QueryResultsModel>(
      `${this.baseUrl}/companies/${
        this.currentUserType === 'Super Admin' ? '0' : this.companyId
      }/docmosis/templates?size=5000`,
      {},
    );
  }

  createTemplate(template: Template): Observable<HttpResponse<{ data: Template }>> {
    return this.http.post<{ data: Template }>(
      `${this.baseUrl}/companies/${
        this.currentUserType === 'Super Admin' ? '0' : this.companyId
      }/docmosis/templates`,
      template,
      { observe: 'response' },
    );
  }

  updateTemplate(template: Template): Observable<HttpResponse<{ data: Template }>> {
    return this.http.put<{ data: Template }>(
      `${this.baseUrl}/companies/${
        this.currentUserType === 'Super Admin' ? '0' : this.companyId
      }/docmosis/templates/${template.id}`,
      template,
      {
        observe: 'response',
      },
    );
  }

  updateTemplateStatus(template: Template): Observable<HttpResponse<void>> {
    return this.http.put<void>(
      `${this.baseUrl}/companies/${
        this.currentUserType === 'Super Admin' ? '0' : this.companyId
      }/docmosis/templates/${template.id}/change-status`,
      { is_active: template.is_active },
      { observe: 'response' },
    );
  }
}
